// extracted by mini-css-extract-plugin
module.exports = {"card":"MCard_card__1K0Fx"};